import React from 'react'
import { FormattedMessage } from 'react-intl'

import { LabelText, HeroTextContainer, TwoStepMultiSelectLabelContainer, Divider } from './style'


const TwoStepMultiSelectLabel = ({ heroText, labelText, active }) => {
  // eslint-disable-next-line no-magic-numbers
  const status = typeof active === 'boolean' ? active : active.length !== 0
  return <TwoStepMultiSelectLabelContainer data-testid='test-label-container'>
    <HeroTextContainer active={status}>
      {heroText}
    </HeroTextContainer>
    <Divider />
    <LabelText>
      <FormattedMessage id={labelText} />
    </LabelText>
  </TwoStepMultiSelectLabelContainer>
}

export default TwoStepMultiSelectLabel
